export default "__VITE_ASSET__zGAYyai___"